import { get } from 'svelte/store';
import { region, type Region } from '$lib/region';
import {
  PUBLIC_FITTINGBOX_TOKEN_US,
  PUBLIC_FITTINGBOX_TOKEN_UK,
  PUBLIC_FITTINGBOX_TOKEN_EU
} from '$env/static/public';

const API_KEYS: Record<Region, string> = {
  eu: PUBLIC_FITTINGBOX_TOKEN_EU,
  uk: PUBLIC_FITTINGBOX_TOKEN_UK,
  us: PUBLIC_FITTINGBOX_TOKEN_US
};

export const isFittingBoxEnabled = (): boolean => {
  const currentRegion = get(region);
  return API_KEYS[currentRegion] != '';
};

export const startVirtualTryOn = (identifier?: string | null) => {
  if (typeof window === 'undefined') return;
  if (!identifier) return;
  window.fitmixInstance.startVto('live');
  window.fitmixInstance.setFrame(String(identifier));
};
